import styled from 'styled-components';

export const StyledUserIdWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;
